import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useEffect } from 'react'

import { useHook } from '../../lenteHooks'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import type { StopAlertsProps } from '../participantOverview/participant/types'

const MoneyInPersonsBundlingStopAlertInternal = ({
  onHandleResourcesInStop,
}: StopAlertsProps) => {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: isInStop } = useHook(
    'fetchers.moneyIn.useFetchMoneyInPersonsBundlingStops',
  )({
    tenantId,
    personId: ownerId,
  })

  useEffect(() => {
    onHandleResourcesInStop((x) => ({ ...x, moneyIn: !!isInStop }))
  }, [isInStop, onHandleResourcesInStop])

  return (
    isInStop && (
      <Alert severity="warning">
        {`${translate('stopAlert.invoiceCreation')}: ${translate('status.stopped')}`}
      </Alert>
    )
  )
}

export const MoneyInPersonsBundlingStopAlert = withLifeErrorBoundary(
  MoneyInPersonsBundlingStopAlertInternal,
)
